/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: garry彭
 * @LastEditTime: 2023-11-19 16:37:54
 */
import React from 'react'
import styles from './index.module.scss'
import { Table } from 'antd'

// 失败数据类型
interface FailedDataItem {
  userName: string
  userMobile: string
  department: string
  mobileStatus: number
}

interface PreviewProps {
  total: number
  failedData: FailedDataItem[]
}

const statusMessages: Record<string, string> = {
  '-1': '已加入该部门',
  '-2': '部门信息有误，请仔细检查部门信息填写是否正确',
  '-3': '服务端出错，请稍后重试',
  '-4': '手机号填写错误',
  '-5': '发送邀请短信失败，请稍后重试',
  '-6': '服务端出错，请稍后重试',
  '-7': '今日已邀请'
}

const Preview: React.FC<PreviewProps> = ({ total, failedData }) => {
  return (
    <div className={styles['preview-wrapper']}>
      <div className={styles['import-info']}>
        <div className={styles['info-title']}>导入结果详情</div>
        <div className={styles['info-content']}>
          <div className={styles['info-left']}>
            <span>
              上传员工数：<i>{total}</i>
            </span>
            <span>
              导入成功：<i>{total - failedData.length}</i>
            </span>
            <span>
              导入失败： <i style={{ color: '#D40000' }}>{failedData.length}</i>
            </span>
          </div>
        </div>
      </div>
      <div className={styles['table-container']}>
        <Table
          columns={[
            {
              title: '姓名（非必填）',
              dataIndex: 'userName'
            },
            {
              title: '手机号',
              dataIndex: 'userMobile'
            },
            {
              title: '部门名称',
              dataIndex: 'department'
            },
            {
              title: '失败原因',
              dataIndex: 'mobileStatus',
              render: (status: number) => {
                return statusMessages[String(status)]
              }
            }
          ]}
          dataSource={failedData}
          rowKey="userMobile"
          pagination={false}
        />
      </div>
    </div>
  )
}

export default Preview
